import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button';
import AddIcon from '@atlaskit/icon/core/add';
import { MOBILE } from '../../utils/constants';
import { Suspense, useState } from 'react';
import { FeedWallHeader } from './feed-header/FeedWallHeader';
import { PostsFeed } from './wall-feed-posts/PostsFeed';
import AskQuestionModal from './ask-question-modal/AskQuestionModal';
import { useFeedWallParams } from 'hooks/useFeedWallParams';

const Forums = () => {
  const { categoryId } = useFeedWallParams();
  const [modalOpen, setModalOpen] = useState(false);

  const handleCloseModal = () => setModalOpen(false);
  const handleOpenModal = () => setModalOpen(true);

  return (
    <div data-testid="forums-container" css={containerStyles}>
      <div css={headingContainerStyles}>
        <h1 css={headingStyles}>{'Forums'}</h1>
        <Button iconBefore={<AddIcon label="" />} onClick={handleOpenModal} appearance="primary">
          Ask a question
        </Button>
        <AskQuestionModal open={modalOpen} onClose={handleCloseModal} />
      </div>
      <FeedWallHeader />
      <Suspense fallback={<div css={loadingStyles}>Loading posts...</div>}>
        <PostsFeed selectedCategory={categoryId || ''} />
      </Suspense>
    </div>
  );
};

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '48px',
  padding: '24px',
  maxWidth: '1200px',
  width: '100%',
  margin: '0 auto',
  [MOBILE.MEDIA_QUERY]: {
    padding: '16px',
  },
});

const headingContainerStyles = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
});

const headingStyles = css({
  fontSize: '40px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '48px',
  letterSpacing: '-0.12px',
  color: token('color.text'),
  fontFamily: 'Charlie Display, sans-serif',
  fontFeatureSettings: `'liga' off, 'clig' off`,
  '@media (max-width: 1279px)': {
    fontSize: '32px',
    lineHeight: '40px',
  },
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '28px',
    lineHeight: '36px',
  },
});

const loadingStyles = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
  fontSize: '16px',
  color: token('color.text.subtle'),
});

export default Forums;
